import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSign, PARTICIPANT_MODAL, CONTROL_MODAL } from 'context/signview';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Table, ButtonGroup } from 'reactstrap';
import { parseDate } from 'utils';

function ParticipantInformation() {

    const [{ modal, participantId, contract }, dispatch] = useSign();

    const { t } = useTranslation();

    const handleClose = () => {
        dispatch({ type: CONTROL_MODAL, close: PARTICIPANT_MODAL })
    }

    const { name, label, status, signDate, isNotSigner, isNotNegotiator } = contract.participants?.find(p => p._id === participantId) || {};

    const isSignerStatus = ['RECEIVED_SIGNED', 'RECEIVED_TO_SIGN', 'SENT_SIGNED'].includes(status);
    const isNegotiator = isNotSigner && !isNotNegotiator && isSignerStatus;
    const isSpectator = isNotSigner && isNotNegotiator && isSignerStatus;
    const statusText = isNegotiator && contract.wasNegotiated ? 'ACCEPTED_NEGOTIATION_2'
            : isNegotiator ? 'NEGOTIATOR' 
         : isSpectator ? 'SPECTATOR' 
         : status;
    return (
        <Modal isOpen={modal.includes(PARTICIPANT_MODAL)} centered>
            <ModalHeader toggle={handleClose}>
                {name}
            </ModalHeader>
            <ModalBody>
                <Table responsive hover>
                    <tbody>
                        <tr className="bg-grey rounded border">
                            <td className="font-weight-bold">{t('sign.participants.name')}:</td>
                            <td>{name}</td>
                        </tr>
                        {/* <tr className="bg-grey rounded border">
                            <td className="font-weight-bold">Email:</td>
                            <td>{email}</td>
                        </tr> */}
                        <tr>
                            <td className="font-weight-bold">{t('sign.participants.obligation')}:</td>
                            <td>{label}</td>
                        </tr>
                        <tr className="bg-grey rounded border">
                            <td className="font-weight-bold">{t('sign.participants.status')}:</td>
                            <td>
                                <i className="fas fa-info-circle"></i>{' '}
                                {t(`contracts.status_v2.${statusText || ''}`)}
                            </td>
                        </tr>
                        <tr hidden={!signDate}>
                            <td className="font-weight-bold">{t('sign.participants.signature_date')}:</td>
                            <td>{parseDate(signDate, 'Pp')}</td>
                        </tr>
                    </tbody>
                </Table>
            </ModalBody>
            <ModalFooter>
                <ButtonGroup className="d-flex flex-grow-1">
                    <Button onClick={handleClose}> {t('common.close')}</Button>
                </ButtonGroup>
            </ModalFooter>
        </Modal>
    )

}
export default ParticipantInformation;